
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/review-products",
      function () {
        return require("private-next-pages/account/review-products.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/review-products"])
      });
    }
  